import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faUpload, faCheck, faSync, faTimes } from '@fortawesome/free-solid-svg-icons';
import './ImportarPacientesTaller.css';

export default function ImportarPacientesTaller({
  isOpen,
  onClose,
  importStep,
  setImportStep,
  importData,
  importSelected,
  importAllSelected,
  importErrors,
  importFileName,
  isUploading,
  onFileChange,
  onToggleAll,
  onToggleRow,
  onImportSelected,
  onChangeRow,
  onResetFile,
  templateUrl
}) {
  if (!isOpen) return null;

  const isError = (index, field) => importErrors[index]?.[field];

  return (
    <div className="modalImportacion">
      <div className="modal-content-importacion">
        <div className="modal-header">
          <div className="header-title-actions">
            <h3>Importar pacientes</h3>
            <div className="header-actions">
              <span className="close" onClick={onClose}>&times;</span>
            </div>
          </div>
        </div>

        {importStep === 1 && (
          <div className="paso-1">
            <div className="paso-indicador">
              <span className="paso-activo">1. Descargar Plantilla</span>
              <span className="paso-inactivo">2. Cargar y Revisar</span>
            </div>
            <div className="instrucciones">
              <h4>Instrucciones:</h4>
              <ul>
                <li>Descarga la plantilla con la estructura correcta.</li>
                <li>Campos requeridos: nombre, telefono, sexo, edad.</li>
                <li>Sexo valido: Hombre, Mujer, No binario.</li>
                <li>Telefono solo numeros.</li>
                <li>Edad en numero entero.</li>
              </ul>
            </div>
            <div className="botones-accion">
              <a className="btn-descargar" href={templateUrl} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faDownload} />
                Descargar Plantilla
              </a>
              <div className="subir-archivo">
                <label htmlFor="excel-file-import-pacientes" className="btn-subir">
                  <FontAwesomeIcon icon={faUpload} />
                  Seleccionar Archivo Excel/CSV
                </label>
                <input
                  id="excel-file-import-pacientes"
                  type="file"
                  accept=".xlsx,.xls,.csv"
                  onChange={onFileChange}
                  style={{ display: 'none' }}
                  disabled={isUploading}
                />
              </div>
            </div>
            {importFileName && (
              <div className="archivo-seleccionado">
                <FontAwesomeIcon icon={faCheck} />
                <span>Archivo seleccionado: {importFileName}</span>
              </div>
            )}
          </div>
        )}

        {importStep === 2 && (
          <div className="paso-2">
            <div className="paso-indicador">
              <span className="paso-completado">1. Descargar Plantilla</span>
              <span className="paso-activo">2. Cargar y Revisar</span>
            </div>
            <div className="resumen-edicion">
              <span>✏️</span>
              <span>
                Puedes <strong>editar cualquier campo</strong> antes de importar. Los campos obligatorios vacios se marcaran en rojo.
              </span>
            </div>
            <div className="usuarios-preview">
              <div className="header-preview">
                <h4>Pacientes a Importar ({importData.length})</h4>
                <div className="acciones-masivas">
                  <label className="switch-toggle">
                    <input
                      type="checkbox"
                      checked={importAllSelected}
                      onChange={(e) => onToggleAll(e.target.checked)}
                    />
                    <span className="slider"></span>
                    <span className="switch-label">
                      {importAllSelected ? 'Deseleccionar Todos' : 'Seleccionar Todos'}
                    </span>
                  </label>
                </div>
                <div className="acciones-importacion">
                  <button
                    className="btn-finalizar btn-sm"
                    onClick={onImportSelected}
                    disabled={importSelected.length === 0 || isUploading}
                  >
                    {isUploading ? (
                      <>
                        <FontAwesomeIcon icon={faSync} spin />
                        Importando...
                      </>
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faUpload} />
                        Importar {importSelected.length}
                      </>
                    )}
                  </button>
                  <button className="btn-cancelar btn-sm" onClick={() => {
                    onResetFile();
                    setImportStep(1);
                  }}>
                    <FontAwesomeIcon icon={faTimes} />
                    Cambiar archivo
                  </button>
                </div>
              </div>
              <div className="tabla-preview">
                <table>
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          checked={importSelected.length === importData.length && importData.length > 0}
                          onChange={(e) => onToggleAll(e.target.checked)}
                        />
                      </th>
                      <th>Nombre</th>
                      <th>Telefono</th>
                      <th>Sexo</th>
                      <th>Edad</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importData.map((paciente, index) => (
                      <tr key={`paciente-${index}`} className={importSelected.includes(index) ? 'seleccionado' : ''}>
                        <td>
                          <input
                            type="checkbox"
                            checked={importSelected.includes(index)}
                            onChange={() => onToggleRow(index)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={paciente.nombre || ''}
                            onChange={(e) => onChangeRow(index, 'nombre', e.target.value)}
                            className={isError(index, 'nombre') ? 'input-error' : ''}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={paciente.telefono || ''}
                            onChange={(e) => onChangeRow(index, 'telefono', e.target.value)}
                            className={isError(index, 'telefono') ? 'input-error' : ''}
                          />
                        </td>
                        <td>
                          <select
                            value={paciente.sexo || ''}
                            onChange={(e) => onChangeRow(index, 'sexo', e.target.value)}
                            className={isError(index, 'sexo') ? 'input-error' : ''}
                          >
                            <option value="">-</option>
                            <option value="Hombre">Hombre</option>
                            <option value="Mujer">Mujer</option>
                            <option value="No binario">No binario</option>
                          </select>
                        </td>
                        <td>
                          <input
                            type="number"
                            value={paciente.edad || ''}
                            onChange={(e) => onChangeRow(index, 'edad', e.target.value)}
                            className={isError(index, 'edad') ? 'input-error' : ''}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
